// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/@whalecloud/fdx-theme-fdx/simple-form/index.less
// module id = 1504
// module chunks = 0